export default __webpack_public_path__ + "static/media/icon-tick.8cf87952.svg";